//=============== HEADER jQuery CODE ===============//
(function ($) {
  "use strict";
  var PUS = {};
  PUS.slicknav = function () {
    $("#mobile-menu").slicknav({
      allowParentLinks: true,
      prependTo: "#mobile-menu-wrap",
      label: "",
    });

    $(".mobile-menu-trigger").on("click", function (e) {
      $(".mobile-menu-container").addClass("menu-open");
      e.stopPropagation();
    });

    $(".mobile-menu-close").on("click", function (e) {
      $(".mobile-menu-container").removeClass("menu-open");
      e.stopPropagation();
    });
  };
  $(document).ready(function () {
    PUS.slicknav();
  });
})(jQuery);

jQuery(document).ready(function ($) {
  $(".rooted-results .benefits-btn").on("click", function () {
    if ($(this).hasClass("active")) {
      // If already active, remove it
      $(this).removeClass("active");
    } else {
      // Otherwise, remove active from others and add to this one
      $(".rooted-results .benefits-btn").removeClass("active");
      $(this).addClass("active");
    }
  });
});


// PREVENTS SCROLL TO TOP WHEN CLICKING ON ANCHOR HASH
// jQuery(document).ready(($) => {
//   $('a[href="#"]').click(function () {
//     return false;
//   });
// });

// new WOW().init();

/* ADD / REMOVE CLASS AFTER SCROLL */
jQuery(window).scroll(function () {
  var scroll = jQuery(window).scrollTop();
  //console.log(scroll);
  if (scroll >= 70) {
    //console.log('a');
    jQuery(".main-header").addClass("header-fixed");
  } else {
    //console.log('a');
    jQuery(".main-header").removeClass("header-fixed");
  }
});
// Trigger the scroll event manually on page load
jQuery(window).trigger("scroll");

jQuery(document).ready(($) => {
  $("img").each(function () {
    const img = $(this);
    const width = img.width();
    const height = img.height();
    const altText = img.attr("alt"); // Get the existing alt attribute

    if (width && height) {
      img.attr("width", width);
      img.attr("height", height);
    }

    if (!altText) {
      img.attr("alt", "Elevate Organic"); // Set a default alt text if none exists
    }
  });
});

(function () {
  // ========================================================================== //
  // ============================ CUSTOM SELECT JS ============================ //
  // ========================================================================== //
  var x, i, j, selElmnt, a, b, c;
  x = document.getElementsByClassName("custom-select-wrapper");
  for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < selElmnt.length; j++) {
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    var x,
      y,
      i,
      arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    for (i = 0; i < y.length; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < x.length; i++) {
      if (arrNo.indexOf(i) == -1) {
        x[i].classList.add("select-hide");
      }
    }
  }

  document.addEventListener("click", closeAllSelect);

  // Accordion functionality
  const accordion = document.getElementById("myAccordion");

  if (accordion) {
    accordion.addEventListener("click", (e) => {
      if (e.target.classList.contains("accordion-button")) {
        const btn = e.target;
        const isExpanded = btn.getAttribute("aria-expanded") === "true";

        // Close all items
        accordion.querySelectorAll(".accordion-button").forEach((button) => {
          button.setAttribute("aria-expanded", "false");
          const collapse = document.getElementById(button.getAttribute("aria-controls"));
          collapse.classList.remove("show");
        });

        // Toggle current item
        if (!isExpanded) {
          btn.setAttribute("aria-expanded", "true");
          const collapse = document.getElementById(btn.getAttribute("aria-controls"));
          collapse.classList.add("show");
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const target = mutation.target;
          if (target.classList.contains("show")) {
            const contentHeight = target.scrollHeight;
            target.style.maxHeight = contentHeight + "px";
            target.style.overflow = "hidden";
            target.style.transition = "max-height 0.3s ease";
          } else {
            target.style.maxHeight = "0px";
          }
        }
      });
    });

    const accordions = document.querySelectorAll(".accordion .accordion-item .accordion-collapse");

    accordions.forEach((acc) => {
      observer.observe(acc, { attributes: true });
    });
  });

  // window.addEventListener("load", () => {
  //   if (window.innerWidth > 767) {
  //     const leftContent = document.querySelector(".accordion-with-image-video .left-content");
  //     const rightContentWrap = document.querySelector(".accordion-with-image-video .right-content .content-wrap");

  //     if (leftContent && rightContentWrap) {
  //       const leftHeight = leftContent.offsetHeight;
  //       rightContentWrap.style.height = `${leftHeight}px`;
  //     }
  //   }
  // });
})();

document.addEventListener("DOMContentLoaded", function () {
  let productContents = document.querySelectorAll(".product-details-wrap");

  let maxHeight = 0;

  // Find the maximum height
  productContents.forEach((content) => {
    let contentHeight = content.offsetHeight;
    if (contentHeight > maxHeight) {
      maxHeight = contentHeight;
    }
  });

  // Apply the maximum height to all elements
  productContents.forEach((content) => {
    content.style.height = maxHeight + "px";
  });
});

const TopSlider = new Swiper(".topBar-slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  autoplay: {
      delay: 4000,
      disableOnInteraction: true,
  },
});

const HomeBannerSlider = new Swiper(".home-banner-slider", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  // autoplay: {
  //     delay: 4000,
  //     disableOnInteraction: true,
  // },
  navigation: {
    nextEl: ".home-banner-slider-swiper-button-next",
    prevEl: ".home-banner-slider-swiper-button-prev",
  },
});

const FeaturedSlider = new Swiper(".featured-slider", {
  slidesPerView: 3,
  spaceBetween: 75,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
  navigation: {
    nextEl: ".feature-swiper-button-next",
    prevEl: ".feature-swiper-button-prev",
  },
  breakpoints: {
    1: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
});

const LogoSlider = new Swiper(".logo-slider", {
  slidesPerView: 5,
  spaceBetween: 75,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
  breakpoints: {
    1: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    576: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 75,
    },
  },
});

const SplitSlider = new Swiper(".split-slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: ".split-swiper-button-next",
    prevEl: ".split-swiper-button-prev",
  },
  on: {
    init: function () {
      updateNavTitles(this);
    },
    slideChange: function () {
      updateNavTitles(this);
    },
  },
});

function updateNavTitles(swiper) {
  const slides = swiper.slides;
  const activeIndex = swiper.activeIndex;
  const totalSlides = slides.length;

  const prevIndex = (activeIndex - 1 + totalSlides) % totalSlides;
  const nextIndex = (activeIndex + 1) % totalSlides;

  const getTitle = (slide) => {
    const fullText = slide?.querySelector(".slide-content-inner .title")?.textContent?.trim() || "";
    return fullText.substring(0, 9);
  };

  const prevTitle = getTitle(slides[prevIndex]);
  const nextTitle = getTitle(slides[nextIndex]);

  document.querySelector(".slider-title-prev").textContent = prevTitle;
  document.querySelector(".slider-title-next").textContent = nextTitle;
}

const ReviewsSlider = new Swiper(".reviews-slider", {
  slidesPerView: 4,
  spaceBetween: 24,
  loop: true,
  // autoplay: {
  //   delay: 4000,
  //   disableOnInteraction: true,
  // },
  navigation: {
    nextEl: ".reviews-swiper-button-next",
    prevEl: ".reviews-swiper-button-prev",
  },
  pagination: {
    el: ".reviews-swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

const FeedSlider = new Swiper(".feed-slider", {
  slidesPerView: 3,
  spaceBetween: 34,
  loop: true,
  // autoplay: {
  //   delay: 4000,
  //   disableOnInteraction: true,
  // },
  navigation: {
    nextEl: ".feed-swiper-button-next",
    prevEl: ".feed-swiper-button-prev",
  },
  breakpoints: {
    1: {
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      centeredSlides: true,
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 2,
    },
    1201: {
      slidesPerView: 3,
    },
    1401: {
      slidesPerView: 3,
    },
  },
});

const FBTProductsSlider = new Swiper(".FBTProductsSlider", {
  slidesPerView: 4,
  spaceBetween: 45,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
  breakpoints: {
    1: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
});

var ProductGallery = new Swiper(".ProductGallery", {
  loop: true,
  spaceBetween: 10,
  slidesPerView: 4,
  // freeMode: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
});

var GalleryThumbs = new Swiper(".GalleryThumbs", {
  loop: true,
  spaceBetween: 10,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  thumbs: {
    swiper: ProductGallery,
  },
});

const GallerySlider = new Swiper(".gallery-slider", {
  slidesPerView: 1,
  spaceBetween: 28,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
  centeredSlides: true,
  grabCursor: true,
});



const tabBtns = document.querySelectorAll(".tab-btn");
const tabContents = document.querySelectorAll(".tab-content");
const activeTabBtn = document.querySelector(".active-tab-btn");
const tabListMobile = document.querySelector(".tab-list-mobile");

function activateTab(btn) {
  const tabId = btn.dataset.tab;

  // Remove all active classes
  tabBtns.forEach((b) => b.classList.remove("active"));
  tabContents.forEach((c) => c.classList.remove("active"));

  // Add active class
  btn.classList.add("active");
  const activeContent = document.getElementById(tabId);
  activeContent.classList.add("active");

  // ✅ Reset Swiper inside this active tab (no ID required)
  const swiperEl = activeContent.querySelector(".swiper");
  if (swiperEl && swiperEl.swiper) {
    swiperEl.swiper.slideToLoop(0, 0); // ✅ use slideToLoop instead of slideTo
  }

  // Update mobile toggle
  if (window.innerWidth < 768) {
    activeTabBtn.querySelector(".label").textContent = btn.textContent;
    tabListMobile.style.display = "none";
    activeTabBtn.querySelector(".icon").textContent = "+";
  }
}

// Attach click handlers to all tab buttons
tabBtns.forEach((btn) => {
  btn.addEventListener("click", () => activateTab(btn));
});

// Toggle mobile dropdown menu
activeTabBtn.addEventListener("click", () => {
  const isOpen = tabListMobile.style.display === "flex";
  tabListMobile.style.display = isOpen ? "none" : "flex";
  activeTabBtn.querySelector(".icon").textContent = isOpen ? "+" : "−";
});

// ✅ Activate first tab on load
window.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".tab-btn.active") && tabBtns.length > 0) {
    activateTab(tabBtns[0]);
  }
});

// ====================================================================================================== //
// ====================================================================================================== //
// ====================================================================================================== //

$(document).ready(function () {
  //============================================
  const topBars = $(".top-bar");
  let currentIndex = 0;

  function toggleOpacity() {
    topBars.removeClass("opacity-100").addClass("opacity-0");
    topBars.eq(currentIndex).removeClass("opacity-0").addClass("opacity-100");
    currentIndex = (currentIndex + 1) % topBars.length;
    setTimeout(toggleOpacity, 3000); // Adjust the delay as needed
  }

  toggleOpacity();

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    $("header").toggleClass("shadow-md header_main", scroll >= 70);
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var spanElement = $("header > span");
    var navElement = $("header .nav_icon span, header .nav_icon small");

    spanElement.toggleClass("bg-transparent", scroll < 70);
    spanElement.toggleClass("bg-tertiary", scroll >= 70);

    navElement.toggleClass("bg-tertiary", scroll < 70);
    navElement.toggleClass("bg-primary", scroll >= 70);
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var spanElement = $("header .navMenu");

    var headerInnerExists = $("header").hasClass("header-alt");

    if (!headerInnerExists) {
      spanElement.toggleClass("text-tertiary", scroll < 70);
      spanElement.toggleClass("text-primary", scroll >= 70);
    }
  });

  const elevateLogo = $(".elevate-logo");

  $(window).scroll(function () {
    const scroll = $(window).scrollTop();

    if (scroll >= 70) {
      elevateLogo.addClass("animate-logo-up");
    } else {
      elevateLogo.removeClass("animate-logo-up");
    }
  });

  //============================================
  // Set default opacity for all tab buttons
  $("[data-tabs-target]").css("opacity", 0.5);

  // Hide all tabs except the first one
  $('[id^="default-tab-content"] > div:not(:first)').addClass("hidden");

  // Find the first button with aria-selected="true" and update styles
  var $initialTab = $("[data-tabs-target]").filter('[aria-selected="true"]');
  $initialTab.css("opacity", 1.0).addClass("border-b");

  // Handle tab button click
  $("[data-tabs-target]").on("click", function () {
    // Hide all tab content
    $('[id^="default-tab-content"] > div').addClass("hidden");

    // Show the selected tab content
    $($(this).data("tabs-target")).removeClass("hidden");

    // Update tab button styles
    $("[data-tabs-target]").css("opacity", 0.5).removeClass("border-b");
    $(this).css("opacity", 1.0).addClass("border-b");
  });

  //=====================================
  // Click event for the buttons
  $(".radio-select").on("click", function () {
    // Remove the 'hidden' class from all spans
    $(".radio-select span").addClass("hidden");

    // Get the index of the clicked button
    var index = $(this).index() + 1;

    // Remove the 'hidden' class from the corresponding span
    $(".selection-text")
      .eq(index - 1)
      .find("span")
      .removeClass("hidden");
  });
  //=====================================
  // Wait for the document to be ready

  // Handle click event on the nav_icon
  $(".nav_icon").click(function () {
    // Toggle the visibility of the menu-mobile on each click
    $(".menu-mobile").toggle();

    $(".nav_icon").toggleClass("group");

    // Toggle the 'menu-open' class on the body to control overflow
    $("body").toggleClass("overflow-hidden");

    // Get the .navMenu element
    var navMenu = $(".navMenu");

    // Toggle classes based on the existence of text-tertiary class
    if (navMenu.hasClass("text-tertiary")) {
      navMenu.removeClass("text-tertiary").addClass("text-primary");
    } else {
      navMenu.removeClass("text-primary").addClass("text-tertiary");
    }

    var headerInnerExists = $(this).closest("header").hasClass("header-alt");

    if (!headerInnerExists) {
      $(this).closest("header").addClass("header-main");
    }

    // Always toggle the menu-open class in .navMenu
    navMenu.toggleClass("menu-open");

    // Adjust margin-top of .elevate-logo div when menu opens
    if (navMenu.hasClass("menu-open")) {
      $(".elevate-logo").css("margin-top", "0");
    } else {
      // Reset margin-top when menu closes
      $(".elevate-logo").css("margin-top", ""); // or "auto" depending on your design
    }
  });
  //=====================================
  // Function to set height based on screen width
  function setHeightBasedOnWidth() {
    // Check the device width
    if ($(window).width() >= 768) {
      // Get the height of the content inside the first class
      var tabContentHeight = $(".tab-wrapper-inner").outerHeight();

      // Set the height of the second class based on the content height
      $(".default-tab-content").css("height", tabContentHeight);
    } else {
      // If the width is less than 768px, reset the height to auto or any desired value
      $(".default-tab-content").css("height", "auto");
    }
  }

  // Initial height setting
  setHeightBasedOnWidth();

  // Listen for window resize events
  $(window).resize(function () {
    // Update height when the window is resized
    setHeightBasedOnWidth();
  });
  //=====================================
  var defaultTab = $("#default-tab");
  var buttons = defaultTab.find(".tab-btn");

  // Show the tab-data of the first button by default
  var firstButton = buttons.first();
  var firstTabData = firstButton.find(".tab-data");
  firstTabData.animate({ height: "toggle" });

  buttons.on("click", function () {
    var clickedButton = $(this);
    var targetTabData = clickedButton.find(".tab-data");

    // Check if the clicked tab is already active
    var isAlreadyActive = targetTabData.is(":visible");

    // Hide all tab-data elements with height animation
    $(".tab-data").not(targetTabData).animate({ height: "hide" });

    // Show the tab-data of the clicked button if it's not already active
    if (!isAlreadyActive) {
      targetTabData.animate({ height: "toggle" });
    }
  });
  //============================================
  $(".btn-review").click(function () {
    // Find the reviews-wrapper element
    var reviewsWrapper = $(".reviews-wrapper");

    // Replace the height class
    reviewsWrapper.removeClass("h-[40rem]").addClass("h-auto");

    // Find the review-shadow element and add the hidden class
    reviewsWrapper.find(".review-shadow").addClass("hidden");

    // Add the hidden class to the button
    $(this).hide();
  });
  //============================================
  // Target the contact form
  var contactForm = $(".type-form");

  // Attach a function to the change event on input and textarea elements within the form
  contactForm.find("input, textarea").on("input", function () {
    // Find the corresponding field wrapper for the current input or textarea
    var fieldWrapper = $(this).closest("[field-wrapper]");

    // Check if the input or textarea has a value
    if ($(this).val().trim() !== "") {
      // Add the not-empty class to the field wrapper
      fieldWrapper.addClass("not-empty");
    } else {
      // Remove the not-empty class from the field wrapper
      fieldWrapper.removeClass("not-empty");
    }
  });

  //=================================
  // Add click event listener to each details element
  $("details").on("click", function () {
    // Close all other details elements
    $("details").not(this).removeAttr("open");
  });

  //================================
  $(".js-toggle-accordion").click(function (e) {
    e.preventDefault(); // Prevent the default behavior of the anchor tag

    var container = $(this).next(".set-details-container");
    var arrow = $(this).find(".set-details-arrow"); // Look for .set-details-arrow within the clicked element

    // Toggle the visibility of the set-details-container
    container.toggleClass("expanded");
    var maxHeight = container.hasClass("expanded") ? container[0].scrollHeight + "px" : "0";
    container.css("max-height", maxHeight);

    // Add or remove classes based on the presence of 'expanded' class
    arrow.toggleClass("transform rotate-180 transition-all duration-300 ease", container.hasClass("expanded"));
  });

  // Hide the login prompt by default
  $(".login-prompt").addClass("hidden");

  // Show login prompt when prompt-btn is clicked
  $(".prompt-btn").click(function () {
    $(".login-prompt").removeClass("hidden");
  });

  // Hide login prompt when prompt-close is clicked
  $(".prompt-close").click(function () {
    $(".login-prompt").addClass("hidden");
  });

  $('[data-step] input[type="radio"]').change(function () {
    var allGroupsChecked = true;

    $('[data-step="' + $(this).closest("[data-step]").attr("data-step") + '"] input[type="radio"]').each(function () {
      var groupName = $(this).attr("name");
      if ($('[name="' + groupName + '"]:checked').length === 0) {
        allGroupsChecked = false;
        return false; // Exit the loop early since we found an unchecked radio in this group
      }
    });
    var stepBtn = $(this).closest("[data-step]").find(".step-button");

    if (allGroupsChecked) {
      if (stepBtn.attr("sold") == undefined) {
        stepBtn.removeAttr("disabled").removeClass("opacity-25 pointer-events-none");
      }
    } else {
      stepBtn.attr("disabled", "disabled").addClass("opacity-25 pointer-events-none");
    }
  });

  // Show choose-plan by default
  $(".choose-plan").addClass("block").removeClass("hidden");

  // Show/hide frequency options based on frequency frequency selection
  $('[data-step] input[name="frequency"]').change(function () {
    var selectedfrequency = $(this).val();
    $("div[data-frequency]").addClass("hidden");
    $('div[data-frequency*="' + selectedfrequency + '"]').removeClass("hidden");
    // Reset selected frequency when changing frequency frequency
    $('input[name="blades"]').prop("checked", false);
    $('input[name="blades"]').trigger("change");
    // Show choose-plan when changing frequency frequency
    $(".choose-plan").removeClass("hidden").addClass("block");
    // Hide data-selected when changing frequency frequency
    $("span[data-selected]").removeClass("block").addClass("hidden");
    // Add hidden class to frequency-label when data-type is checked
    $("div[data-frequency-label]").addClass("hidden");
  });

  // When expanding the details element
  $("#choose-plan").on("toggle", function () {
    if ($(this).prop("open")) {
      // Details element is expanded
      // Show choose-plan
      $(".choose-plan").removeClass("hidden").addClass("block");
      // Hide data-selected
      $("span[data-selected]").removeClass("block").addClass("hidden");
    } else {
      // Details element is collapsed
      var selectedFrequency = $('#choose-plan input[name="blades"]:checked').siblings("label").text();
      $("span[data-selected]").text(selectedFrequency);
      if ($('input[name="blades"]:checked').length > 0) {
        $("span[data-selected]").removeClass("hidden").addClass("block");
        $(".choose-plan").removeClass("block").addClass("hidden");
      }
    }
  });

  // When both frequency and plan are checked, collapse the details element
  $('input[name="blades"]').change(function () {
    if ($('[data-step] input[name="frequency"]:checked').length > 0 && $('input[name="blades"]:checked').length > 0) {
      $("#choose-plan").removeAttr("open");
    }
  });
});

$(document).ready(function () {
  // Listen for changes in the data-added attribute of any .product-card
  $(".product-card").on("DOMSubtreeModified", function () {
    var hasDataAdded = false;
    // Loop through each .product-card
    $(".product-card").each(function () {
      // Check if the current .product-card has the data-added attribute
      if ($(this).attr("data-added")) {
        hasDataAdded = true;
        return false; // Exit the loop if data-added attribute is found
      }
    });
    // Check if any .product-card has data-added attribute
    if (hasDataAdded) {
      // If any .product-card has data-added attribute, add hidden class to .skip-button
      $(".skip-button").addClass("hidden");
    } else {
      // If no .product-card has data-added attribute, remove hidden class from .skip-button
      $(".skip-button").removeClass("hidden");
    }
  });
});

$(document).ready(function () {
  // Initialize a variable to store the maximum height
  var maxHeight = 0;

  // Iterate over each .flip-box-content to find the maximum height
  $(".flip-box-content").each(function () {
    // Get the current height of the flip-box-content
    var currentHeight = $(this).outerHeight();

    // Update maxHeight if the current height is greater
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });

  // Apply the maximum height to all .flip-box elements
  $(".flip-box").css("height", maxHeight);
  $(".flip-box-content").css("height", maxHeight);
});

function generateWave(element) {
  let wave = document.querySelector(element);
  if (wave) {
    const width = wave.getBoundingClientRect().width;
    const height = wave.getBoundingClientRect().height;
    const offset = height - 50;
    const amplitude = width < 500 ? 15 : 25;
    const frequency = width < 500 ? 0.7 : 1.1;
    const phase = width < 500 ? -50 : -80;
    const points = 30;
    const inverted = true;
    const units = (2 * Math.PI * frequency) / points;
    const path = "clip-path: polygon(100% 100%, 0% 100% ";
    const invertedpath = "clip-path: polygon(100% 0%, 0% 0% ";

    let clipPathString = path;
    if (inverted) clipPathString = invertedpath;

    let radPhase = (phase * Math.PI) / 180;

    for (let i = 0; i <= points; i++) {
      let val = offset + amplitude * Math.cos(i * units + radPhase);
      let valY = ((val / height) * 100).toFixed(2);
      let valX = ((i * 100) / points).toFixed(2);
      clipPathString += ", " + valX + "% " + valY + "%";
    }
    clipPathString += ");";
    wave.style = clipPathString;
  }
}

(() => {
  generateWave(".wave-container");
})();
